// Slike - Desktop
const heroIllustrationLeft = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/left-illustration.webp";
const heroIllustrationRight = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/right-illustration.webp";

// Slike - Mobile (optimizirane)
const heroIllustrationLeftMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/left-illustration-mobile.webp";
const heroIllustrationRightMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/right-illustration-mobile.webp";
const sangriaLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/sangria-logo-mobile.png";

// Partner logi - Mobile (optimizirani)
const ptpLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/cropped-ptpfavicon1-01.png";
const luiLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/logolui-1.svg";
const inkubatorKocevjeLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/inkubator-logotip-500x300-97148896.png";
const sasaInkubatorLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/sasainkubator.png";
const tovarnaPodjemovLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/tovarnapodjemov-logo-1.png";
const katapultLogoMobile = "https://swdwbeofkwiutzjdfrtc.supabase.co/storage/v1/object/public/blog-images/logokatapult.svg";

import sangriaLogo from "@/assets/sangria-logo.png";
import ptpLogo from "@/assets/partners/ptp-logo.png";
import luiLogo from "@/assets/partners/lui-logo.svg";
import inkubatorKocevjeLogo from "@/assets/partners/inkubator-kocevje-logo.webp";
import sasaInkubatorLogo from "@/assets/partners/sasa-inkubator-logo.png";
import tovarnaPodjemovLogo from "@/assets/partners/tovarna-podjemov-logo.png";
import katapultLogo from "@/assets/partners/katapult-logo.svg";
import delavnica1 from "@/assets/delavnica-1.jpg";
import delavnica2 from "@/assets/delavnica-2.jpg";
import delavnica3 from "@/assets/delavnica-3.jpg";
import tanjaSasaInkubator from "@/assets/tanja-sasa-inkubator.jpg";
import hanaKucejQrSpace from "@/assets/hana-kucej-qr-space.jpg";
import blazZupanEf from "@/assets/blaz-zupan-ef.jpg";

// ===========================
// HEADER
// ===========================
export const headerContent = {
  navigation: {
    paketi: "Paketi",
    delavnice: "Delavnice",
  },
  ctaButton: "Brezplačni posvet",
};

// ===========================
// HERO
// ===========================
export const heroContent = {
  logo: sangriaLogo, // Will be overridden dynamically from CMS
  title: "Računovodstvo za startupe",
  subtitle: "Od prvega računa do prvega investitorja",
  ctaButton: {
    withPricing: "Rezerviraj brezplačni posvet",
    waitlist: "Vpiši se na čakalni seznam",
  },
  socialProof: {
    text: "Sodelujemo z vodilnimi slovenskimi inkubatorji in startup programi",
    partners: [
      { logo: ptpLogo, alt: "Primorski Tehnološki Park" },
      { logo: luiLogo, alt: "LUI" },
      { logo: inkubatorKocevjeLogo, alt: "Podjetniški Inkubator Kočevje" },
      { logo: sasaInkubatorLogo, alt: "SAŠA Inkubator" },
      { logo: tovarnaPodjemovLogo, alt: "Tovarna Podjemov" },
      { logo: katapultLogo, alt: "Katapult" },
    ],
  },
  illustrations: {
    left: heroIllustrationLeft,
    right: heroIllustrationRight,
    leftMobile: heroIllustrationLeftMobile,
    rightMobile: heroIllustrationRightMobile,
  },
  logoMobile: sangriaLogoMobile,
  socialProofMobile: {
    partners: [
      { logo: ptpLogoMobile, alt: "Primorski Tehnološki Park" },
      { logo: luiLogoMobile, alt: "LUI" },
      { logo: inkubatorKocevjeLogoMobile, alt: "Podjetniški Inkubator Kočevje" },
      { logo: sasaInkubatorLogoMobile, alt: "SAŠA Inkubator" },
      { logo: tovarnaPodjemovLogoMobile, alt: "Tovarna Podjemov" },
      { logo: katapultLogoMobile, alt: "Katapult" },
    ],
  },
};

// ===========================
// ZAKAJ IZBRATI NAS (WHY US)
// ===========================
export const whyUsContent = {
  title: "Zakaj izbrati nas?",
  subtitle: "Smo prvi računovodski servis v Sloveniji, ki je zgrajen za potrebe startupov.",
  benefits: [
    {
      title: "Razumemo tvojo pot",
      description:
        "Sami prihajamo iz startup sveta. Zato razumemo tempo, kaos in željo po rasti. Ne govorimo le o računih, ampak o ciljih, procesih, runwayu in produktu, ki ga gradiš.",
    },
    {
      title: "Osredotočeni na KPI-je in rast",
      description:
        "Partner, ne samo računovodja. Pomagamo ti postaviti KPI-je, cashflow in finančne metrike, ki zanimajo investitorje. Tvoje številke pretvorimo v odločitve, ki poganjajo rast.",
    },
    {
      title: "Ekipa izkušenih founderjev",
      description:
        "Sangrio vodi ekipa računovodij in serijskih startup founderjev z več kot 15-letnimi izkušnjami pri ustanavljanju podjetij, vodenju ekip, prodaji, marketingu in fundraisingu.",
    },
  ],
};

// ===========================
// PAKETI (PACKAGES)
// ===========================
export const packagesContent = {
  title: "Simpl poslovni model",
  subtitle: "Izberi paket, ki ustreza tvoji fazi rasti",
  ctaButton: {
    withPricing: "Rezerviraj brezplačni posvet",
    waitlist: "Pridruži se",
  },
  termsLabel: "Pravila obsega dela",
  packages: [
    {
      name: "Kickstart",
      description: "Za čisto nove podjetnike",
      price: "€129",
      features: ["Osnovno računovodstvo", "Pomoč pri registraciji", "Mesečno poročanje", "Email podpora", ""],
      terms: [
        "Preseganje obsega knjižb: Če stranka v kateremkoli koledarskem mesecu preseže 80 knjižb/dokumentov, se avtomatsko prenese v paket »Growth« (349 €/mesec), z veljavnostjo od prvega dne naslednjega meseca.",
        "Zunanji partnerji: Cena ne vključuje stroškov zunanjih pravnih in davčnih svetovalcev.",
      ],
    },
    {
      name: "Growth",
      description: "Za startupe s prvimi prihodki",
      price: "€349",
      features: [
        "Vse iz Kickstart paketa",
        "Cashflow upravljanje",
        "Plačilne liste",
        "KPI & OKR svetovanje",
        "Mesečni video posvet",
      ],
      popular: true,
      terms: [
        "Preseganje obsega knjižb: Če stranka v kateremkoli koledarskem mesecu preseže 250 knjižb/dokumentov, se avtomatsko prenese v paket »Scale« (749 €/mesec).",
        "Dodatni zaposleni: Obračun plače za vsakega zaposlenega nad 5 oseb se doplača 45 €/osebo/mesec. Če število zaposlenih trajno preseže 10, se stranka prenese v paket »Scale«.",
        "Zunanji partnerji: Cena ne vključuje stroškov zunanjih pravnih in davčnih svetovalcev.",
      ],
    },
    {
      name: "Scale",
      description: "Za startupe v rasti",
      price: "€749",
      features: [
        "Vse iz Growth paketa",
        "CFO svetovanje",
        "Poročila za investitorje",
        "Due diligence podpora",
        "Tedenski posvet",
      ],
      terms: [
        "Izredne storitve: Cena vključuje neomejen obseg rednega računovodstva in CFO svetovanja. Izredne storitve, kot so celovita revizija preteklega poslovanja, priprava kompleksnih vlog za razpise ali uradna pravna mnenja (izven rednega obsega), se zaračunajo po urni postavki 95 €/uro.",
        "Zunanji partnerji: Povezovanje z zunanjimi strokovnjaki je vključeno, vendar njihove storitve (davčno svetovanje, pravne storitve) niso vključene v ceno paketa in se zaračunajo po njihovem ceniku.",
      ],
    },
  ],
  popularBadge: "Najbolj priljubljeno",
};

// ===========================
// KAKO DELUJE (HOW IT WORKS)
// ===========================
export const howItWorksContent = {
  title: "Ne čakaj in začni",
  subtitle: "Trije enostavni koraki do urejenega računovodstva",
  steps: [
    {
      title: "Rezerviraj brezplačni posvet",
      description: "Izpolni kratek obrazec, nam povej več o svojem startupu in rezerviraj brezplačni posvet.",
    },
    {
      title: "Video klic",
      description: "Na brezplačnem video klicu skupaj ugotovimo, kaj potrebuješ in kako ti lahko pomagamo.",
    },
    {
      title: "Onboarding v nekaj dneh",
      description: "Ko se odločiš za sodelovanje, postavimo sistem in poskrbimo za vse računovodske obveznosti.",
    },
  ],
  stepLabel: "Korak",
};

// ===========================
// DELAVNICE (WORKSHOPS)
// ===========================
export const workshopsContent = {
  title: "Delavnice za startupe in podjetja v fazi rasti",
  subtitle:
    "Poleg računovodskih storitev ponujamo tudi interaktivne delavnice, kjer founderje in njihove ekipe naučimo ključnih finančnih veščin, prodaje in marketinga.",
  images: [delavnica1, delavnica2, delavnica3],
  workshops: [
    {
      title: "Finančna pismenost in planiranje",
      description:
        "Razumevanje finančnih izkazov, finančno planiranje, postavljanje KPI-jev, cash flow management in priprava finančnih poročil za produktne ekipe in vodje.",
    },
    {
      title: "Prodaja in marketing",
      description:
        "Kako se lotiti prvih korakov prodaje in marketinga. Kako določiti segment strank, kaj so prodajni kanali, prodajna veriga in product market fit. Postavljanje cene.",
    },
    {
      title: "Priprava na fundraising",
      description:
        "Kako pripraviti svoje finance, da se lahko začnemo pogovarjati z investitorji. Kako iskati in se pogovarjati z investitorji in kje so skrite pasti term sheetov.",
    },
  ],
  ctaButton: "Rezerviraj brezplačni posvet",
  discount: {
    icon: "🎁",
    text: "Naročnikom paketnih storitev Sangria pri izvedbi delavnic podarimo popust v višini",
    percentage: "20 %",
  },
};

// ===========================
// SOCIAL PROOF (TESTIMONIALS)
// ===========================
export const socialProofContent = {
  title: "Zadovoljni naročniki",
  subtitle: "Startupi in partnerji, ki soustvarjajo prihodnost računovodstva v Sloveniji",
  testimonials: [
    {
      quote: "Končno računovodski servis, ki razume, da smo hitri in potrebujemo jasne odgovore.",
      author: "Hana Kučej, CEO & Co-Founder",
      company: "QR Space",
      imageUrl: hanaKucejQrSpace,
    },
    {
      quote:
        "V ekipi Sangria so odlični predavatelji in praktiki, ki znajo kompleksne teme s področja podjetništva, marketinga in rasti podjetja predstaviti na zelo razumljiv in uporaben način. Udeleženci so vedno navdušeni nad njihovo energijo, konkretnimi primeri in jasnimi nasveti za prakso.",
      author: "Blaž Zupan, profesor & podjetnik",
      company: "Ekonomska Fakulteta, UL",
      imageUrl: blazZupanEf,
    },
    {
      quote:
        "Njihove praktične delavnice o prodaji in marketingu, zasnovane na resničnih izkušnjah, so ena največjih dodanih vrednosti našega Startup Generator programa.",
      author: "Tanja Ževart Boček, direktorica",
      company: "Saša Inkubator",
      imageUrl: tanjaSasaInkubator,
    },
  ],
};

// ===========================
// FAQ
// ===========================
export const faqContent = {
  title: "Pogosta vprašanja",
  subtitle: "Vse, kar moraš vedeti o naših storitvah",
  faqs: [
    {
      question: "Kaj je Sangria?",
      answer:
        "Sangria je prvi računovodski servis v Sloveniji, ustvarjen za startupe. Digitalno, pregledno in človeško. Namesto obrazcev dobiš partnerja, ki razume tvoj produkt, KPI-je in pot do investicije.",
    },
    {
      question: "Kaj pomeni, da ste računovodstvo za startupe?",
      answer:
        "Ne gre le za bilance. Naučimo te, kako upravljati s financami. Pomagamo ti postaviti procese, KPI-je, razumeti številke, narediti prve korake v prodaji in marektingu. Tebe in tvoj startup pripravimo na sodelovanje z investitorji. Računovodstvo je šele začetek — rast je cilj.",
    },
    {
      question: "Pomagate tudi pri ustanovitvi podjetja?",
      answer:
        "Seveda. Pomagamo ti izbrati, ali je zate primernejši s.p. ali d.o.o., te vodimo skozi registracijo na SPOT-u in pripravimo vse začetne dokumente. Ti prineseš idejo, mi uredimo papirje.",
    },
    {
      question: "Kako hitro lahko začnem?",
      answer:
        "Onboarding traja 2–5 dni. Po prijavi se slišimo, skupaj preletimo osnove, nastavimo sistem in tvoj startup je pripravljen za rast.",
    },
    {
      question: "Kaj če prerastem paket?",
      answer:
        "Ko tvoj startup zraste, te preklopimo na višji paket — brez zapletov, brez izgube podatkov in z enako ekipo, ki pozna tvojo zgodbo.",
    },
    {
      question: "Ali pomagate tudi pri davkih?",
      answer:
        "Da. Skrbimo za obračune DDV, dohodnine, prispevkov in davčne optimizacije. Davčni jezik prevedemo v startup jezik, da razumeš, kaj se dogaja s tvojim denarjem.",
    },
    {
      question: "Ali delate tudi s tujimi investitorji?",
      answer:
        "Da! Pripravljamo poročila v angleškem jeziku in poznamo zahteve mednarodnih investitorjev ter standardov poročanja. Tvoj startup je lahko globalen — mi gremo s tabo.",
    },
    {
      question: "Kako poteka sodelovanje z vami?",
      answer:
        "Smo remote-first računovodstvo, brez klasičnih pisarn. Vse poteka na daljavo, digitalno in preprosto – preko telefona ali video klica. Ob priložnosti se z veseljem srečamo tudi v živo ob kavi, ker verjamemo, da prava partnerstva nastajajo iz pogovora, ne iz tabel.",
    },
    {
      question: "Kdo stoji za Sangrio?",
      answer:
        "Ekipa izkušenih računovodij in serijskih startup podjetnikov z več kot 15-letnimi izkušnjami pri ustanavljanju podjetij, vodenju ekip, prodaji, marketingu in fundraisingu.",
    },
    {
      question: "Zakaj ime Sangria?",
      answer:
        "Ker računovodstvo ni nujno dolgočasno. Sangria je lahkotna, barvita in prijetna — tako kot bi morale biti tudi tvoje finance. 🍹",
    },
  ],
};

// ===========================
// KONČNI CTA
// ===========================
export const finalCtaContent = {
  title: "Ali smo za skupaj?",
  subtitle: "Rezerviraj brezplačni posvet, da skupaj ugotovimo, kaj najbolj ustreza tvojim potrebam.",
  ctaButton: "Rezerviraj brezplačni posvet",
};

// ===========================
// FOOTER
// ===========================
export const footerContent = {
  logo: sangriaLogo,
  tagline: "Računovodstvo za startupe",
  email: "hi@sangria.si",
  socialLinks: [
    { platform: "Instagram", url: "#", ariaLabel: "Instagram" },
    { platform: "YouTube", url: "#", ariaLabel: "YouTube" },
    { platform: "LinkedIn", url: "https://www.linkedin.com/company/sangriasi", ariaLabel: "LinkedIn" },
    { platform: "TikTok", url: "#", ariaLabel: "TikTok" },
  ],
  navigation: {
    title: "Povezave",
    links: [
      { label: "Priboljški", url: "/priboljski" },
      { label: "Blog", url: "/blog" },
      { label: "Zaposlitev", url: "/zaposlitev" },
    ],
  },
  legal: {
    copyright: "© 2026 Sangria. Vse pravice pridržane.",
    links: [
      { label: "Pogoji uporabe", url: "/pogoji-uporabe" },
      { label: "Zasebnost", url: "/zasebnost" },
      { label: "Piškotki", url: "/piskotki" },
    ],
  },
};

// ===========================
// CONTACT FORM
// ===========================
export const contactFormContent = {
  title: {
    withPricing: "Rezerviraj brezplačni posvet",
    waitlist: "Vpiši se na čakalni seznam",
  },
  description: {
    withPricing: "Povej nam več o svojem startupu in izberemo najboljši paket zate.",
    waitlist: "Postani del prvih startupov, ki soustvarjajo novo računovodsko storitev.",
  },
  fields: {
    name: {
      label: "Ime in priimek",
      placeholder: "Janez Novak",
    },
    email: {
      label: "Email",
      placeholder: "janez@startup.si",
    },
    phone: {
      label: "Telefonska številka",
      placeholder: "+386 XX XXX XXX",
    },
    company: {
      label: "Ime podjetja / startupa",
      placeholder: "Moj Startup d.o.o.",
    },
    website: {
      label: "Spletna stran (neobvezno)",
      placeholder: "https://mojstartup.si",
    },
    message: {
      label: "Sporočilo (neobvezno)",
      placeholder: "Povej nam malo več o svojem startupu...",
    },
  },
  submitButton: {
    withPricing: "Rezerviraj brezplačni posvet",
    waitlist: "Vpiši se",
  },
  successMessage: {
    withPricing: {
      title: "Povpraševanje poslano!",
      description: "Odgovorili ti bomo v najkrajšem možnem času.",
    },
    waitlist: {
      title: "Uspešno si se vpisal na čakalni seznam!",
      description: "Kmalu te bomo kontaktirali z več informacijami.",
    },
  },
};
